module.exports = __webpack_public_path__ + "img/upload.e5e0ba40.png";